import Cookies from 'js-cookie'
import { TOKEN_KEY, USER_KEY } from '@/store/auth.js'
import { useLanguageStore } from '@/store/language.js'
import router from '@/plugins/router.js'

export function setupInterceptors(axios) {
  axios.interceptors.request.use(
    (config) => {
      const token = Cookies.get(TOKEN_KEY)
      if (token) {
        config.headers.Authorization = token
      }

      const languageStore = useLanguageStore()
      if (languageStore.currentLocale) {
        config.headers['X-locale'] = languageStore.currentLocale
      }

      return config
    },
    (error) => Promise.reject(error)
  )

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error.response?.status

      if ([500, 404].includes(status)) {
        console.error(`API Error: ${status}`)
      }

      if (status === 401) {
        Cookies.remove(TOKEN_KEY)
        Cookies.remove(USER_KEY)
        router.push('/login')
      }

      return Promise.reject(error)
    }
  )
}
